import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AWSElasticsearchReader5xForm from '../forms/aws-elasticsearch-reader-5x-form';
import { awsElasticsearchReader5xValidationSchema } from '../schema/awsElasticsearchReader5x.js';

export default function AWSElasticSearchReader5xNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'AWS Elasticsearch Reader 5x Node Details',
        altText: 'AWS Elasticsearch Reader 5x Node',
        defaultLabel: 'AWS Elasticsearch Reader 5x Node',
      }}
    >
      <CommonNode
        FormComponent={AWSElasticsearchReader5xForm}
        schemaResolver={awsElasticsearchReader5xValidationSchema}
      />
    </NodeProvider>
  );
}
